import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';

export const Root = styled(Paper)(() => ({
	/** Driver's app has mobile-size width always */
	maxWidth: MOBILE_CONTAINER_WIDTH,
	margin: '0 auto',
	height: '100%',
	backgroundColor: 'unset',
}));
